import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-link-new-tab',
    templateUrl: './link-new-tab.component.html',
    styleUrls: ['./link-new-tab.component.scss'],
})
export class LinkNewTabComponent {
    @Input() href?: string

    openLink() {
        if (this.href) {
            window.open(
                this.href.indexOf('www') === 0
                    ? 'https://' + this.href
                    : this.href,
                '_blank'
            )
        }
    }
}
